import React from 'react';
import styles from './containerList.module.css';

// Helper: Capitalize only the first letter
function capitalizeFirst(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const formatApptTimeRange = (start, end) => {
  if (!start || !end) return '';
  const s = start.split(' ')[0];
  const e = end.split(' ')[0];
  return `(${s}-${e})`;
};

const formatApptDate = (dateString, hourStart, hourEnd) => {
  if (!dateString) return '';

  if (
    typeof dateString === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(dateString)
  ) {
    const [year, month, day] = dateString.split('-');
    return `${month}-${day}-${year}`;
  }

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  if (!hourStart || !hourEnd) {
    return date.toISOString().split('T')[0];
  }
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

// Helper for safe appointment access
const hasAppointments = (container) =>
  Array.isArray(container?.appointments) && container.appointments.length > 0;

const AppointmentDisplay = ({ container, activeTab, collapsedRow }) => {
  if (collapsedRow) {
    return null;
  }

  // Available tab
  if (activeTab === 'available') {
    if (
      container?.appointments !== null &&
      container?.appointments?.length > 0
    ) {
      return (
        <div className={styles.containerRightInfoDiv}>
          <div className={styles.appointmentRow}>
            <div className={styles.leftInfo}>
              <span className={styles.mainTitle}>
                {container?.appointments[0]?.terminal?.slug}
              </span>
              <span className={styles.moreCount}>
                {container.appointments.length > 1
                  ? `+${container.appointments.length - 1} more`
                  : ''}
              </span>
            </div>
            <div className={styles.rightInfo}>
              <span className={styles.missedBadge}>
                {capitalizeFirst(container?.appointments[0]?.status_text)}
              </span>
            </div>
          </div>
          <div className={styles.appointmentDetails}>
            <span className={styles.date}>
              {formatApptDate(
                container?.appointments[0]?.reserve_history[0]?.date,
                container?.appointments[0]?.reserve_history[0]?.time_start,
                container?.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
            <span className={styles.time}>
              {formatApptTimeRange(
                container?.appointments[0]?.reserve_history[0]?.time_start,
                container?.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
            {container?.appointments[0]?.appointment_id && (
              <span className={styles.hash}>
                #{container?.appointments[0]?.appointment_id}
              </span>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.rightInfo}>
          <span className={styles.availableBadge}>Available</span>
        </div>
      );
    }
  }

  // Appointed tab
  if (activeTab === 'appointed') {
    if (Array.isArray(container?.appointments) && container?.appointments[0]) {
      return (
        <div className={styles.containerRightInfoDiv}>
          <div className={styles.appointmentRow}>
            <div className={styles.leftInfo}>
              <span className={styles.mainTitle}>
                {container?.appointments[0]?.terminal?.slug}
              </span>
              <span className={styles.moreCount}>
                {container.appointments.length > 1
                  ? `+${container.appointments.length - 1} more`
                  : ''}
              </span>
            </div>
            <div className={styles.rightInfo}>
              <span className={styles.appointedBadge}>
                {capitalizeFirst(container?.appointments[0]?.status_text)}
              </span>
            </div>
          </div>
          <div className={styles.appointmentDetails}>
            <span className={styles.date}>
              {formatApptDate(
                container?.appointments[0]?.reserve_history[0]?.date,
                container?.appointments[0]?.reserve_history[0]?.time_start,
                container?.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
            <span className={styles.time}>
              {formatApptTimeRange(
                container?.appointments[0]?.reserve_history[0]?.time_start,
                container?.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
            {container?.appointments[0]?.appointment_id && (
              <span className={styles.hash}>
                #{container?.appointments[0]?.appointment_id}
              </span>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.rightInfo}>
          <span className={styles.appointedBadge}>Appointed</span>
        </div>
      );
    }
  }

  // In-Gated tab
  if (activeTab === 'inGated') {
    return (
      <div className={styles.containerRightInfoDiv}>
        <div className={styles.appointmentRow}>
          <div className={styles.leftInfo}>
            {hasAppointments(container) &&
            Array.isArray(container.appointments) &&
            container.appointments.length > 0 ? (
              <span className={styles.mainTitle}>
                {container?.appointments[0]?.terminal?.slug}
              </span>
            ) : (
              ''
            )}

            {hasAppointments(container) &&
            Array.isArray(container.appointments) &&
            container.appointments.length > 0 ? (
              <span className={styles.moreCount}>
                {container.appointments.length > 1
                  ? `+${container.appointments.length - 1} more`
                  : ''}
              </span>
            ) : (
              ''
            )}
          </div>
          <div className={styles.rightInfo}>
            {hasAppointments(container) &&
            Array.isArray(container.appointments) &&
            container.appointments.length > 0 ? (
              <span className={styles.inGatedBadge}>
                {container.appointments[0]?.status_text}
              </span>
            ) : (
              <span className={styles.inGatedBadge}>In-Gated</span>
            )}
          </div>
        </div>
        <div className={styles.appointmentDetails}>
          <span className={styles.date}>
            {container?.gated_in
              ? formatApptDate(container?.gated_in, '00:00 AM', '11:59 PM')
              : hasAppointments(container) &&
                Array.isArray(container.appointments) &&
                container.appointments.length > 0
              ? formatApptDate(
                  container.appointments[0]?.reserve_history[0]?.date,
                  '00:00 AM',
                  '11:59 PM'
                )
              : ''}
          </span>
          {container?.gated_in ? (
            ''
          ) : hasAppointments(container) &&
            Array.isArray(container.appointments) &&
            container.appointments.length > 0 ? (
            <span className={styles.time}>
              {formatApptTimeRange(
                container.appointments[0]?.reserve_history[0]?.time_start,
                container.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
          ) : (
            ''
          )}

          {hasAppointments(container) &&
            Array.isArray(container.appointments) &&
            container.appointments.length > 0 && (
              <span className={styles.hash}>
                #{container?.appointments[0]?.appointment_id}
              </span>
            )}
        </div>
      </div>
    );
  }

  // Street Turned tab
  if (activeTab === 'streetTurned') {
    if (
      container?.appointments !== null &&
      container?.appointments?.length > 0
    ) {
      return (
        <div className={styles.containerRightInfoDiv}>
          <div className={styles.appointmentRow}>
            <div className={styles.leftInfo}>
              <span className={styles.mainTitle}>
                {container?.appointments[0]?.terminal?.slug}
              </span>
              <span className={styles.moreCount}>
                {container.appointments.length > 1
                  ? `+${container.appointments.length - 1} more`
                  : ''}
              </span>
            </div>
            <div className={styles.rightInfo}>
              <span className={styles.streetTurnedBadge}>
                {capitalizeFirst(container?.appointments[0]?.status_text)}
              </span>
            </div>
          </div>
          <div className={styles.appointmentDetails}>
            <span className={styles.date}>
              {formatApptDate(
                container?.appointments[0]?.reserve_history[0]?.date,
                container?.appointments[0]?.reserve_history[0]?.time_start,
                container?.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
            <span className={styles.time}>
              {formatApptTimeRange(
                container?.appointments[0]?.reserve_history[0]?.time_start,
                container?.appointments[0]?.reserve_history[0]?.time_end
              )}
            </span>
            {container?.appointments[0]?.appointment_id && (
              <span className={styles.hash}>
                #{container?.appointments[0]?.appointment_id}
              </span>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.rightInfo}>
          <span className={styles.streetTurnedBadge}>Street Turned</span>
        </div>
      );
    }
  }

  // Default case - return empty string
  return '';
};

export default AppointmentDisplay;
